import React from 'react'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/kindColorControl.less'

type KindColorControlProps = {
  color?: string | undefined
  onChange: (color: string) => void
}

const KindColorControl = ({ color, onChange }: KindColorControlProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)

  return (
    <div className={cn('control', 'kind-color-control')} data-graph-type="control" title="Kind color">
      <input
        className="kind-color-swatch"
        type="color"
        value={color || '#888888'}
        onChange={handleChange}
        aria-label="Kind color"
      />
    </div>
  )
}

export default KindColorControl
